import BaseClass from "../../libs/base/BaseClass";
import gsap from "gsap";

/**
 * 要素開閉の基礎クラス
 * @example
 <a href="" data-toggle_target="chosenGoing">内訳を表示</a>
 <div class="toggle_target" data-toggle_id="chosenGoing">
 <div class="toggle_target_inner"></div>
 </div><!-- /toggle_target -->

 初期オープン状態にする
 <div class="toggle_target" data-toggle_id="chosenGoing" data-toggle_defaultopen>
 <div class="toggle_target_inner"></div>
 </div><!-- /toggle_target -->
 */
export default class ToggleBaseClass extends BaseClass{
    constructor(_id,_parent){
        super();
        this.name = "ToggleBaseClass";

        this.onClickToggleListener = this.onClick_toggle.bind(this);

        this.CL_OPEN = "isOpen";
        this.time = 0.3;
        this.ease = "power2.out";
        this.isOpen = false;
        this.id = _id;
        this.parent = _parent;
    }

    onCreate() {
        this.clickTarget = $('[data-toggle_target='+this.id+']',this.parent);
        this.toggleTarget = $('[data-toggle_id='+this.id+']',this.parent);

        const isDefaultOpen = (this.toggleTarget.filter('[data-toggle_defaultopen]').length > 0);
        if(isDefaultOpen){
            this.isOpen = true;
            this.toggleTarget.css({height:"auto"});
            this.toggleTarget.addClass(this.CL_OPEN);
            this.clickTarget.addClass(this.CL_OPEN);
        }

        this.clickTarget.on("click",this.onClickToggleListener);
    }

    onClick_toggle(e){
        e.preventDefault();
        if(this.isOpen){
            this.onClose();
        } else {
            this.onOpen();
        }
    }

    onOpen(){
        if(this.isOpen) return;
        this.isOpen = true;

        this.toggleTarget.addClass(this.CL_OPEN);
        this.clickTarget.addClass(this.CL_OPEN);

        const h = $(".toggle_target_inner",this.toggleTarget).outerHeight(true);
        gsap.killTweensOf(this.toggleTarget);
        gsap.to(this.toggleTarget,{duration:this.time,height:h,ease:this.ease,onComplete:()=>{
                this.toggleTarget.css({height:"auto"});
                $(window).trigger("resize");
            }
        });
    }

    onClose(){
        if(!this.isOpen) return;
        this.isOpen = false;

        this.toggleTarget.removeClass(this.CL_OPEN);
        this.clickTarget.removeClass(this.CL_OPEN);

        gsap.killTweensOf(this.toggleTarget);
        gsap.to(this.toggleTarget,{duration:this.time,height:0,ease:this.ease,onComplete:()=>{
                $(window).trigger("resize");
            }
        });
    }

    onJustClose(){
        if(!this.isOpen) return;
        this.isOpen = false;

        this.toggleTarget.removeClass(this.CL_OPEN);
        this.clickTarget.removeClass(this.CL_OPEN);
        gsap.killTweensOf(this.toggleTarget);
        this.toggleTarget.css({height:0});
        $(window).trigger("resize");
    }
}